export const SIGN_IN_INITIATED = 'SIGN_IN_INITIATED';
export const SIGN_IN_REQUESTED = 'SIGN_IN_REQUESTED';
export const SIGN_IN_REQUESTED_ERROR = 'SIGN_IN_REQUESTED_ERROR';
export const SIGN_IN_REQUESTED_SUCCESS = 'SIGN_IN_REQUESTED_SUCCESS';

export const initiateSignIn = ({ email, password }) => ({
  type: SIGN_IN_INITIATED,
  email,
  password,
});
export const requestSignIn = () => ({ type: SIGN_IN_REQUESTED });
export const requestSignInError = () => ({ type: SIGN_IN_REQUESTED_ERROR });
export const requestSignInSuccess = user => ({ type: SIGN_IN_REQUESTED_SUCCESS, user });



// WEBPACK FOOTER //
// ./src/redux/actions/signIn.js